import i18n from 'i18next';

export const errorTypes = {
    // 找不到 passcode
    ERROR: 'error',
    // passcode 已經被別人使用過，不可再使用
    DUPLICATE: 'duplicate',
    // 這個 entry 需要 passcode 才能加加活動，但是沒有提供
    ENTRY_NEED_PASSCODE: 'entry-need-passcode',
    // 這個 passcode 參家活動的剩餘次數已經用完了
    USAGE_LIMIT_EXCEEDED: 'usage-limit-exceeded',
    // reCaptcha 驗證失敗
    RECAPTCHA_TOK_AUTH_FAILED: 'reCaptcha-token-authorize-failed'
};

// 1 : 不重複序號, 2 : 單一序號, 3 : 自行上傳, 4 : 即時不重複序號, 5 : 門市人員產生的通關序號
export const passcodeTypes = {
    UNIQUE_CODE: 1,
    SINGLE_CODE: 2,
    UPLOAD_CODE: 3,
    REALTIME_UNIQUE_CODE: 4,
    ONSITE_ASSISTANT_CODE: 5
};

export function getPasscodeErrorType(resp = {}) {
    const { httpStatus, payload } = resp;
    const code = String(payload.code).toLowerCase();

    switch (true) {
        // check entry and passcode status
        case httpStatus === 403 && code === 'epc-v0-ff1':
            return errorTypes.ENTRY_NEED_PASSCODE;
        // set game result and need passcode
        case httpStatus === 400 && code === 'epc-v0-ff1':
            return errorTypes.ENTRY_NEED_PASSCODE;
        // Verify passcode and passcode used to limit
        case httpStatus === 400 && code === 'pc-r1-f0':
            return errorTypes.USAGE_LIMIT_EXCEEDED;
        // Verify passcode and passcode not found
        case httpStatus === 400 && code === 'pc-r1-fnf1':
            return errorTypes.ERROR;
        // Submit passcode and different member (passcode was used)
        case httpStatus === 400 && code === 'ent-r1-ff1':
            return errorTypes.DUPLICATE;
        case httpStatus === 400 && payload?.message === 'reCaptcha token authorize failed - empty':
        case httpStatus === 400 && payload?.message === 'reCaptcha token authorize failed':
            return errorTypes.RECAPTCHA_TOK_AUTH_FAILED;
        // TODO: 400 待確認
        case httpStatus === 400 && payload?.message === 'already have entry flow':
        case httpStatus === 400 && payload?.message === 'passcode not available':
        case httpStatus === 400 && payload?.message === 'no entry':
        default:
            return errorTypes.ERROR;
    }
}

export function getErrorTypeMessage(type) {
    switch (type) {
        case errorTypes.DUPLICATE:
        case errorTypes.USAGE_LIMIT_EXCEEDED:
            return i18n.t('label.passcode.verify.validate.duplicate');
        case errorTypes.ERROR:
        default:
            return i18n.t('label.passcode.verify.validate.error');
    }
}

export function getErrorTypeDialogDesc(type) {
    switch (type) {
        case errorTypes.DUPLICATE:
            return i18n.t('label.passcode.duplicate');
        case errorTypes.USAGE_LIMIT_EXCEEDED:
            return i18n.t('label.passcode.reach_limit');
        case errorTypes.ERROR:
        default:
            return i18n.t('label.passcode.invalid');
    }
}
